import React, { useEffect, useRef, useState } from "react";
import SimpleTable from "../../components/simple-table";
import { Box, Divider, Flex, Tr, Td,Th, MenuList, Text, Image, Menu, MenuButton, MenuItem } from "@chakra-ui/react";
import MiniSideBar from "../../components/mini-sidebar";
import Loader from "../../components/loader/loader";
import SecondaryNav from "../../components/seconday-nav";
import useLoader from "../../components/loader/loaderstates";
import { DropdownInput, PrimaryButton, PrimaryInput, Toaster } from "../../components";
import { formatDate_Do_MMM_YYYY, formatDate_YYYY_MM_DD, getAddressInfo, getCurrency, getHospitalName, getLogo, getUniqueNames } from "../../auth";
import { FetchFilteredMasterTransferReportByPharmacy, FetchMasterTransferReportByPharmacy, FetchTransferReportByPharmacy } from "../../middleware/services/pharmacy";
import { FiCalendar, FiClock, FiUser } from "react-icons/fi";
import { IoDocumentTextOutline } from "react-icons/io5";
import ModalRight from "../../components/modal-right";
import DatePicker from "../../components/date-picker";
import { format, max } from "date-fns";
import { MdOutlineLocalPharmacy } from "react-icons/md";
import moment from "moment";
import { FetchTransferMedicineList, GenerateMedicineRequest, getBatchNumbers, getPharmacy, getURN, saveMedicineTransfer } from "../../middleware/services/profile";
import { FetchInvoice } from "../../middleware/services/billing";
import { COLORS } from "../../components/styles/colors";
import DynamicModal from "../../components/dynamic-modal";


const MasterTransferReportByPharmacy = () => {
const initialRow = {
  medicinename: '',
  medicinenamedisplay: '',
  batchnumber: '',
  mrp: '',
  quantity: '',
  totalamount: '',
  inventoryid: '',
  prescriptionid: '',
  labname: '',
  doctorname: '',
  remainingquantity:'',
  totalCgst:'',
  totalSgst:'',
  sgst:'',
  cgst:'',
  dosage: '',
  dosageunit: '',
  medicinetype: '',
};

  const { isLoading, showLoader, dismissLoader } = useLoader();
  const [totalItemCount, setTotalItemCount] = useState(0);
    const { showSuccessToast, showErrorToast } = Toaster();
  let itemPerPageCommonValue = 50;
  let [countTo, setCountTo] = useState(itemPerPageCommonValue);
  let [countFrom, setCountFrom] = useState(1);
  let [totalExceedsPageCount, setTotalExceedsPageCount] = useState(false);
  let [pagesize, setPagesize] = useState(itemPerPageCommonValue);
  let [currentPage, setCurrentPage] = useState(1);
  let [totalPages, setTotalPages] = useState(1);
  let [pageno, setPageno] = useState(1);
  const [data, setData] = useState([]);
  const [selectedReport, setSelectedReport] = useState(null);
  const [editableQuantities, setEditableQuantities] = useState([]);
  const [toDateMinMax, setToDateMinMax] = useState("")
  const [fromDateMinMax, setFromDateMinMax] = useState("")
  var [fromDate, setFromDate] = useState(null);
  var [toDate, setToDate] = useState(null);
  const [pharmacyNamesList, setPharmacyNamesList] = useState([]);
  const [selectedPharmacyName, setSelectedPharmacyName] = useState("");
  const [selectedPharmacyId, setSelectedPharmacyId] = useState(null);
  const [allPharmacies, setAllPharmacies] = useState([]);
  const [search, setSearch] = useState({
    urn: "",
    medicinecount: "",
  });
  const [Address, setAddressDetails] = useState([]);
  const [hospitalname, setHospitalName] = useState("");
  const [hospitallogo, setHospitalLogo] = useState("");
  const [currency, setCurrency] = useState("");
  const [medicineList, setMedicineList] = useState([]);
  const [ShowPrescription, setShowPrescription] = useState(true);
  const [InvoiceNumber, setInvoiceNumber] = useState(null);
  const [rows, setRows] = useState([]);
  const [ inputId , setInputId ] = useState("");
  const [batchData, setBatchData] = useState([]); 
  const [batchNums, setBatchNums] = useState([]); 
  const [showBatchDropdown, setShowBatchDropdown] = useState(-1);
  const [showBatchDropdownSelectedReport, setShowBatchDropdownSelectedReport] = useState(-1);
  const [showMedicineNamesDropdown, setShowMedicineNamesDropdown] = useState(-1);
  const [boolValForSuggestions, setBoolValForSuggestions] = useState(true);
  const [suggestions, setSuggestions] = useState([]);
  const [transferMedicineName, setTransferMedicineName] = useState({
    productname: "",
    dosage: "",
    dosageunit: "",
    producttype: ""
  })
  const [focusedItemIndex, setFocusedItemIndex] = useState(-1);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [showRemove, setShowRemove] = useState(null);
  const [QuantityInStrip, setQuantityInStrip] = useState(0);
  const [pharmacyData, setPharmacyData] = useState([]);
  const [resultPharmacy, setResultPharmacy] = useState([]);
  const [searchValue, setSearchValue] = useState([]);
  const [pharmacyTypeFilter, setPharmacyTypeFilter] = useState("")
  const [requestMedicineData, setRequestMedicineData] = useState({
    urnNumber: "",
    date: "",
    inputDate: "",
    initiatedBy: "",
    pharmacyList: [],
  });
  const [selectedPharmacy, setSelectedPharmacy] = useState({
    pharmacyname: "",
    pharmacyid: "",
  });
  const transferReportModal = React.useRef(null);
  const openReqModal = useRef();
  const medicineRef = useRef();
  const suggestionsMenuRef = useRef(null);
  const quantityRef = useRef(null);
  const deleteRowModal = useRef();
  const deleteReqModal = useRef();
  var pharmacyId = new URLSearchParams(window.location.search).get(
    "pharmacyid"
  );
  const fetchData = async () => {
    showLoader();
    let input = {
      pharmacyid: pharmacyId || null,
      urn: "",
      medicinecount: "",
      pageno: pageno, 
      pagesize: pagesize,
    };
    try {
      const result = await FetchMasterTransferReportByPharmacy(input);
      // console.log("result", result);
      if (result.result === "success") {
        setData(result.data);
        setAllPharmacies(result.data);
        const filteredPharmacy = getUniqueNames(result?.data);
        setPharmacyNamesList(filteredPharmacy);
        let count = result?.count;
        let pageno = result?.pageno;
        let pagesize = result?.pagesize;
        setTotalItemCount(count);
        let totalPagesCalc = count / pagesize;
        let totalPagesCount = Math.ceil(totalPagesCalc);
        setTotalPages(totalPagesCount);
        if (count < itemPerPageCommonValue) {
          setCountTo(count);
          setTotalExceedsPageCount(true);
        } else if (count > itemPerPageCommonValue && pageno == 1) {
          setCountTo(itemPerPageCommonValue);
          setTotalExceedsPageCount(false);
        }
      } 
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      dismissLoader();
    }
  };

  const handleFilterKeyDown = (event) => {
    if (event.key === "Enter") {
      getFilteredResults();
    }
  };

  const getFilteredResults = async () => {
    showLoader();
    let input = {
      urn: search.urn || null,
      "startdate": formatDate_YYYY_MM_DD(fromDate),
      "enddate": formatDate_YYYY_MM_DD(toDate),
      medicinecount:search.medicinecount || null,
      pharmacyid: selectedPharmacyId || null,
      pageno: pageno,
      pagesize,
    };
    try {
      const result = await FetchFilteredMasterTransferReportByPharmacy(input);
      // console.log("result", result);
      if (result.result === "success") {
        setData(result?.data);
        let count = result?.count;
        let pageno = result?.pageno;
        let pagesize = result?.pagesize;
        setTotalItemCount(count);
        let totalPagesCalc = count / pagesize;
        let totalPagesCount = Math.ceil(totalPagesCalc);
        setTotalPages(totalPagesCount);
        if (count < itemPerPageCommonValue) {
          setCountTo(count);
          setTotalExceedsPageCount(true);
        } else if (count > itemPerPageCommonValue && pageno == 1) {
          setCountTo(itemPerPageCommonValue);
          setTotalExceedsPageCount(false);
        }
      } else {
        setData([])
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      dismissLoader();
    }
  };

  const resetFeilds = () => {
    setSearch({
      urn: "",
      medicinecount: "",
    });
    setFromDate('')
    setToDate('')
    setFromDateMinMax(null)
    setToDateMinMax(null)
    setPagesize(itemPerPageCommonValue);
    setCountFrom(1)
    setCountTo(itemPerPageCommonValue)
    setCurrentPage(1)
    setSelectedPharmacyName("");
    setSelectedPharmacyId(null);
    fetchData()
  };

  useEffect(() => {
    fetchData();
  }, [pageno]); 
  

  const handleFilterInputChange = (e) => {
    const { name, value } = e.target;
    setSearch((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  async function openTransferModal(data) {
    let input = {
        "transferreportid":data.id,
    }
    showLoader();
    try {
        const result = await FetchTransferReportByPharmacy(input);
        // console.log("result", result);
        if (result.result === "success") {
            setSelectedReport(result);
            transferReportModal.current.openRight();
        } 
    } catch (error) {
        console.error("Error fetching data:", error);
    } finally {
        dismissLoader();
    }
  }

  useEffect(() => {
  if (selectedReport?.data && selectedReport.data.length > 0) {
    setEditableQuantities(selectedReport.data.map(item => item.requestedquantity || 0));
  } else {
    setEditableQuantities([]);
  }
}, [selectedReport]);


  async function openRequestModal(data) {
    let input = {
        "transferreportid":data.id,
    }
    showLoader();
    try {
        const result = await FetchTransferReportByPharmacy(input);
        // console.log("result", result);
        if (result.result === "success") {
            setSelectedReport(result);
            openReqModal.current.openRight();
          } 
    } catch (error) {
        console.error("Error fetching data:", error);
    } finally {
        dismissLoader();
    }
  }

  const handleNextClick = () => {
    let page = pageno + 1;
    setPageno(page);
    setCurrentPage(currentPage + 1);
    if (countTo + pagesize < totalItemCount) {
      setCountTo(countTo + pagesize);
    } else {
      setCountTo(totalItemCount);
    }

    setCountFrom(countFrom + pagesize);
  };
  const handlePrevClick = () => {
    let page = pageno - 1;
    setPageno(page);
    setCurrentPage(currentPage - 1);
    setCurrentPage(currentPage - 1);
    if (countTo == totalItemCount) {
      let updatedCountUnroundedValue = totalItemCount - pagesize;
      setCountTo(
        Math.ceil(updatedCountUnroundedValue / itemPerPageCommonValue) *
          itemPerPageCommonValue
      );
    } else {
      setCountTo(countTo - pagesize);
    }

    setCountFrom(countFrom - pagesize);
  };

  const TableHeader = [
    { key: "urn", label: "URN" },
    { key: "count", label: "Medicine Count" },
    { key: "pharmacyname", label: "Pharmacy Name" },
    { key: "initiatedby", label: "Initiated By" },
    { key: "date", label: "Date" },
    { key: "time", label: "Time" },
    { key: "status", label: "Status" },
    { key: "action", label: "Action" },
  ];
  const ModalTable = [
    { key: "productname", label: "Medicine Name" },
    { key: "strength", label: "Strength" },
    { key: "batchnumber", label: "Batch Number" },
    { key: "expirydate", label: "Expiry Date" },
    { key: "manufacturername", label: "Manufacturer" },
    { key: "transferquantity", label: "Transfer Qty" },
  ];


  function formattedTime(rawTime) {
    var formatTime = new Date(rawTime).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    return formatTime;
  }

  const handleFromDate = (selectedDate) => {
    const formattedDate = format(selectedDate, "dd-MM-yyyy");
    setFromDate(formattedDate);

    setFromDateMinMax(selectedDate);
  };

  const handleToDate = (selectedDate) => {
    const formattedDate = format(selectedDate, "dd-MM-yyyy");
    setToDate(formattedDate);
    setToDateMinMax(selectedDate);
  };

  function handlePharmacyNameChange(name) {
    setSelectedPharmacyName(name || "");
    const selected = allPharmacies.find(
      item => item.pharmacyname?.trim().toLowerCase() === (name || "").trim().toLowerCase()
    );
    if (selected) {
      setSelectedPharmacyId(selected.pharmacyid);
    } else {
      setSelectedPharmacyId(null);
    }
  }

  const gobackfunction = ()=>{
    window.history.back();
   }

  const fetchMedicines = async () => {
    try {
      const result = await FetchTransferMedicineList({
        doctor:'',
        type:"catalog"
        });
      if (result.output.data.length > 0) {
        setMedicineList(result.output.data);
        setShowPrescription(true);
      }
      dismissLoader();
    } catch (error) {
      console.error("Error in home:", error);
    }
  };

  const fetchInvoiceNumber = async () => {
    try {
      const result = await FetchInvoice({ 
        doctorid: '',
        });
      if (result.output.invoicenumber) {
        setInvoiceNumber(result.output.invoicenumber)
      }

      dismissLoader();
    } catch (error) {
      console.error("Error in home:", error);
    }
  };

  const AddAnotherRowPrescription = () => {
    const initialRow = {
      medicinename: '',
      batchnumber: '',
      mrp: '',
      quantity: '',
      totalamount: '',
      inventoryid: '',
      prescriptionid: '',
      labname: '',
    };
    setRows((prevRows) => {
      const newRows = [...prevRows, { ...initialRow }];
      // focusInput(newRows.length - 1);
      return newRows;
    });
  };
  

  // const focusInput = (index) => {
  //   setTimeout(() => {
  //     const element = document.getElementById(`medicinename-${index}`);
  //     if (element) {
  //       element.focus();
  //     }
  //   }, 100);
  // };
  
  useEffect(() => {
    fetchMedicines();
    fetchInvoiceNumber();
    // setRows([{...initialRow}]);
    const currency = getCurrency();
    if(currency == "USD"){
      const uscurrency = '$'
      setCurrency(uscurrency);
    }else{
    setCurrency(currency);
    }
    const add = getAddressInfo();
    setAddressDetails(add);
    var hospitallogo = getLogo();
    //var imagepath = "https://midocfileserver.blob.core.windows.net/midocdev/";
    if(hospitallogo){
      setHospitalLogo(hospitallogo)
    }
    var hospitalname = getHospitalName();
    if(hospitalname){
      setHospitalName(hospitalname)
    }
    
  }, []);

  const handleMedicineNameChange = (id, name, index) => {
    // console.log('name: ', name)
    // setInputId(index)
    const newRows = [...rows];
    newRows[index].medicinename = name;
    if (!name) {
      newRows[index] = { ...initialRow }; // Reset the entire row if medicine name is cleared
    }
    setRows(newRows);

    if (name.length >= 3) { // Check if the length of the name is 3 or more characters
      filterMedicineNames(name);
      setShowMedicineNamesDropdown(index);
      setBoolValForSuggestions(!boolValForSuggestions);
    } else {
      setSuggestions([]);
      setShowMedicineNamesDropdown(-1);
      setBoolValForSuggestions(!boolValForSuggestions);
    }
  };

  const FetchBatchList = async (params) => {
    // console.log("params", params)
    // console.log("transferMedicineName", transferMedicineName)
    // let medicineName;
    // if(params !== "") {
    //   medicineName = params;
    // } else 
    if(params.productname == "") {
        showErrorToast("Please select any medicine!")
        return;
      } 
      // else {
      //   medicineName = transferMedicineName;
      // }
    var inputForGet = {
      "medicinename": params.productname || "",
      medicinetype: params?.producttype || "",
      strength: params?.dosage || "",
      strengthunit: params?.dosageunit || "",
    };
    showLoader();
    try {
      var result = await getBatchNumbers(inputForGet);
      // console.log(result.output.data, "batch number call data")
      if (result && result.output.result === "success") {
        setBatchNums(result.output.data);
        setBatchData(result.output.data); // Store the full batch data
      } else {
        setBatchNums([]);
        setBatchData([]);
      }
    } catch (error) {
      console.log(error, "Something went wrong in doctor profile");
    } finally {
      dismissLoader();
    }
  };

  const filterMedicineNames = (medicine) => {
    const filtered = medicineList.filter((obj) =>
      obj.medicinename?.toLowerCase().includes(medicine.toLowerCase())
  );
    setTransferMedicineName(filtered)

    setSuggestions(filtered);
    setBoolValForSuggestions(!boolValForSuggestions);
  };
  const handleBatchNumberChange = (batch, index) => {
    const newRows = [...rows];
    newRows[index].batchnumber = batch;
    setRows(newRows);
  };
  
  const openGenerateReqModal = async () => {
    showLoader();
    try {
      const urnData = await getURN({})
      const pharmacyList = getUniqueNames(pharmacyData)
      const date = new Date();
      const formatted = moment(date).format('Do MMMM YYYY');
      const inputFormatted = moment(date).format('YYYY-MM-DD');
      let firstname = localStorage.getItem("firstname");
      let lastname = localStorage.getItem("lastname");
      let fullName = firstname + " " + lastname;
      if(urnData.output.result === "success" && pharmacyList.length > 0) {
        setRequestMedicineData({
          urnNumber: urnData.output?.urn,
          date: formatted,
          inputDate: inputFormatted,
          initiatedBy: fullName,
          pharmacyList: pharmacyList
        });
        openReqModal.current.openRight();
      }

    } catch(error){
      console.log("Error fetching URN data", error);
    } finally {
      dismissLoader()
    }
  }

  const handleSelect = (suggestion, index) => {
    setTransferMedicineName(suggestion.medicinename)
    const newRows = [...rows];
    // newRows[index].medicinename = suggestion.medicinename  + " ("+suggestion.remainingquantity+" Qty)";
    newRows[index].medicinename = suggestion.medicinename;
    newRows[index].medicinenamedisplay = suggestion.medicinename;
    newRows[index].batchnumber = suggestion.batchnumber;
    newRows[index].mrp = suggestion.costperstrip;
    newRows[index].inventoryid = suggestion.inventoryid;
    newRows[index].remainingquantity = suggestion.remainingquantity;
    newRows[index].sgst = suggestion.sgst;
    newRows[index].cgst = suggestion.cgst;
    newRows[index].dosage = suggestion.dosage;
    newRows[index].dosageunit = suggestion.dosageunit;
    newRows[index].medicinetype = suggestion.medicinetype;
    setQuantityInStrip(suggestion.quantityineachstrip);
    calculateTotalAmount(index);
    setRows(newRows);
    setSuggestions([]);
    setShowMedicineNamesDropdown(-1);
    setFocusedItemIndex(-1);  // Reset the focused item index after selection
    // focusInput("quantity"); // Focus logic
  };

  const handleBatchSelect = (batch, index) => {
    const newRows = [...rows];
    newRows[index].batchnumber = `${batch.batchnumber} (${batch.remainingquantity} Qty)`;
    newRows[index].inventoryid = batch.inventoryid;
    newRows[index].remainingquantity = batch.remainingquantity; // Store the max quantity
    newRows[index].quantity = batch.remainingquantity; // Auto-populate the quantity
    setRows(newRows);
  };

const handleBatchSelectSelectedReport = (batch, index) => {
  setSelectedReport(prev => {
    if (!prev?.data) return prev;
    const updatedData = [...prev.data];
    const originalRequestedQty = updatedData[index].requestedquantity || 0;
    const newQty = editableQuantities[index]
    updatedData[index] = {
      ...updatedData[index],
      batchnumber: `${batch.batchnumber} (${batch.remainingquantity} Qty)`,
      inventoryid: batch.inventoryid,
      requestedquantity: originalRequestedQty,
      remainingquantity: newQty,
    };
    setShowRemove(null);
    return {
      ...prev,
      data: updatedData,
    };
  });
  
  setShowBatchDropdownSelectedReport(-1);
};



const handleQuantityChange = (quantity, index) => {
  const newRows = [...rows];
  
  // Convert to numbers for comparison
  const enteredQty = parseInt(quantity) || 0;
  const maxQty = parseInt(newRows[index].remainingquantity) || 0;

  if (enteredQty > maxQty) {
    showErrorToast(`Quantity cannot exceed available stock (${maxQty})`);
    newRows[index].quantity = maxQty; // Reset to max quantity
  } else {
    newRows[index].quantity = quantity;
  }

  setRows(newRows);
  calculateTotalAmount(index);
  calculateTotalCgstSumForDisplay();
  calculateTotalSgstSumForDisplay();
};

const handleQuantityChangeSelectedReport = (quantity, index) => {
  setSelectedReport(prev => {
    if (!prev?.data) return prev;
    const updatedData = [...prev.data];

    // If input is empty, keep requestedquantity empty string (to allow clearing input)
    if (quantity === "") {
      updatedData[index].requestedquantity = "";
    } else {
      const enteredQty = parseInt(quantity);
      const maxQty = parseInt(updatedData[index].remainingquantity) || 0;
      
      if (enteredQty > maxQty) {
        showErrorToast(`Quantity cannot exceed available stock (${maxQty})`);
        updatedData[index].requestedquantity = maxQty; // Reset to max quantity
      } else if (enteredQty < 0) {
        updatedData[index].requestedquantity = 0; // Optional: don't allow negative values
      } else {
        updatedData[index].requestedquantity = enteredQty;
      }
    }
    return { ...prev, data: updatedData };
  });
};



const confirmDeleteRow = (index, operation) => {
  setRowToDelete({ index, operation });
  if (operation === "selectedReport") {
    deleteReqModal.current.openModal();
  } else {
    deleteRowModal.current.openModal();
  }
};

const calculateTotalAmount = (index) => {
  const newRows = [...rows];
  if (QuantityInStrip && newRows[index].mrp) {
    newRows[index].totalamount = ((newRows[index].mrp / QuantityInStrip) * newRows[index].quantity).toFixed(2);
  } else {
    newRows[index].totalamount = ((newRows[index].mrp / 10) * newRows[index].quantity).toFixed(2);
  }
  setRows(newRows);
};

const calculateTotalCgstSumForDisplay = () => {
  //const totalCgst = rows.reduce((total, row) => total + parseFloat(row.totalCgst || 0), 0);
  const totalCgst = rows.reduce((total, row) => {
    const totalAmount = parseFloat(row.totalamount || 0);
    const cgstPercentage = parseFloat(row.cgst || 0);
    const cgstValue = (cgstPercentage / 100) * totalAmount;
    return total + cgstValue;
  }, 0);
  return `${currency} ${totalCgst.toFixed(2)}`;
};

const calculateTotalSgstSumForDisplay = () => {
  //const totalSgst = rows.reduce((total, row) => total + parseFloat(row.totalSgst || 0), 0);
  const totalSgst = rows.reduce((total, row) => {
    const totalAmount = parseFloat(row.totalamount || 0);
    const sgstPercentage = parseFloat(row.sgst || 0);
    const sgstValue = (sgstPercentage / 100) * totalAmount;
    return total + sgstValue;
  }, 0);
  return `${currency} ${totalSgst.toFixed(2)}`;
};

// const deleteRowHandler = () => {
//   const newRows = rows.filter((_, i) => i !== rowToDelete);
//   setRows(newRows);
//   deleteRowModal.current.closeModal();
// };


const deleteRowHandler = () => {
  const { index, operation } = rowToDelete;

  if (operation === 'selectedReport') {
    // setSelectedReport(prev => {
    //   if (!prev?.data) return prev;
    //   const updatedData = [...prev.data];
    //   updatedData[index] = {
    //     ...updatedData[index],
    //     requestedquantity: 0,
    //   };
    //   return {
    //     ...prev,
    //     data: updatedData,
    //   };
    // });
    setEditableQuantities(prev => {
      const updated = [...prev];
      updated[index] = 0;
      return updated;
    });
    setShowRemove(index);
    deleteReqModal.current.closeModal();
  } else {
    setRows(prevRows => prevRows.filter((_, i) => i !== index));
    deleteRowModal.current.closeModal();
  }

};


const deleteReqHandler = () => {
  const newRows = rows.filter((_, i) => i !== rowToDelete);
  setRows(newRows);
  deleteReqModal.current.closeModal();
};

  const handleSaveTransfer = async () => {
    // const requestedMedicines = selectedReport?.data.filter(req => req.medicinename && req.quantity).map(req => ({
    //   inventoryid: req.inventoryid,
    //   catalogid: req.catalogid,
    //   quantity: parseInt(req.quantity),
    //   medicinename: req.medicinename,
    //   batchnumber: req.batchnumber.includes(' (') 
    //     ? req.batchnumber.split(' (')[0] 
    //     : req.batchnumber
    // }));

    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      const displayRowNum = selectedReport.data.length + i + 1;

      if ((!row.medicinename || row.medicinename.trim() === "") && (!row.quantity || row.quantity === "")) {
        continue;
      }
      if (!row.medicinename || row.medicinename.trim() === "") {
        showErrorToast(`Please enter medicine name for row ${displayRowNum}`);
        return;
      }
      if (!row.quantity || isNaN(row.quantity) || parseInt(row.quantity) <= 0) {
        showErrorToast(`Please enter valid quantity for row ${displayRowNum}`);
        return;
      }
    }
    
    for (let i = 0; i < selectedReport.data.length; i++) {
      const row = selectedReport.data[i];
      const displayRowNum = i + 1;

      if ((!row.productname || row.productname.trim() === "") && (!editableQuantities[i] || editableQuantities[i] === "")) {
        continue;
      }
      if (!row.productname || row.productname.trim() === "") {
        showErrorToast(`Please enter medicine name for row ${displayRowNum}`);
        return;
      }
      if (!row.batchnumber || row.batchnumber === "") {
        showErrorToast(`Please select batch number for row ${displayRowNum}`);
        return;
      }
      if (!editableQuantities[i] || isNaN(editableQuantities[i]) || parseInt(editableQuantities[i]) <= 0) {
        showErrorToast(`Please enter valid quantity for row ${displayRowNum}`);
        return;
      }
    }

    const requestedMedicines = selectedReport.data
      .filter((req, i) => req.productname && editableQuantities[i] > 0)
      .map((req, i) => ({
        inventoryid: req.inventoryid,
        catalogid: req.catalogid,
        quantity: parseInt(editableQuantities[i]),  // <-- use editableQuantities here
        medicinename: req.productname,
        batchnumber: req.batchnumber?.includes(' (') 
          ? req.batchnumber.split(' (')[0] 
          : req.batchnumber
      }));

    const newMedicines = rows.filter(row => row.medicinename && row.quantity).map(row => ({
      inventoryid: row.inventoryid,
      catalogid: row.catalogid,
      quantity: parseInt(row.quantity),
      medicinename: row.medicinename,
      batchnumber: row.batchnumber.includes(' (') 
        ? row.batchnumber.split(' (')[0] 
        : row.batchnumber
    }));

    const medicineDetails = [...requestedMedicines, ...newMedicines];
    
    if (medicineDetails.length === 0) {
      showErrorToast("Please add at least one medicine");
      return;
    }

    const transferInput = {
      pharmacyid: selectedReport.tranferdetails.pharmacyid ,
      urn: selectedReport.tranferdetails.urn || "",
      transferdate: moment(selectedReport.tranferdetails.inputDate).format('YYYY-MM-DD') || "",
      medicinedetails: medicineDetails
    };
    showLoader();
    try {
      
      const result = await saveMedicineTransfer(transferInput);
      if (result.output.result === "success") {
        setPharmacyData("")
        setSelectedPharmacy("")
        getPharmacyList()
        showSuccessToast("Transfer saved successfully!");
        setRows([{...initialRow}]);
        openReqModal.current.closeRight();
        fetchData()
      } else {
        showErrorToast(result.output.message || "Failed to save transfer");
      }
    } catch (error) {
      console.error("Save error:", error);
      showErrorToast("Error saving transfer");
    } finally {
      dismissLoader();
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleFilter();
    }
  };


  const getPharmacyList = async () => {
    var inputForGet = {};
    showLoader();
    try {
      var result = await getPharmacy(inputForGet);

      if (result && result.output.data) {
        setResultPharmacy(result.output.data);
        setPharmacyData(result.output.data);
        // console.log(result.output.data, "result of doctor profile");
      }else {
        setResultPharmacy([])
      }
    } catch (error) {
      console.log(error, "Something went wrong in doctor profile");
    } finally {
      dismissLoader();
    }
  };
  async function handleFilter() {
    const trimmedName = searchValue;
    const inputToFetch = {
      input: {
        "pharmacyname": trimmedName,
        "pharmcytype": pharmacyTypeFilter
      },
    };
    showLoader();
    try {
      const result = await getPharmacy(inputToFetch.input);
      if (result && result.output.data) {
        setResultPharmacy(result.output.data);
      }
    } catch (error) {
      console.log("Error fetching Refer center data", error);
    }
    dismissLoader();
  }
  return (
    <>
      <Box w="100%">
        <Flex>
          <Box w="6rem">
            <MiniSideBar />
          </Box>
          {isLoading && <Loader />}
          <Box width="calc(100vw - 6.25rem)">
            <SecondaryNav withBack="Pharmacy Transfer Report" goBack={gobackfunction} />
            <Box
              gap="10px"
              my="1rem"
              px="1rem"
              w="100%"
              display="flex"
              flexDirection="row"
              justifyContent="start"
              alignItems="center"
            >
              <PrimaryInput
                variant="fullRound"
                title="URN"
                inputPlace="URN"
                id="searchProductName"
                name="urn"
                inputValue={search.urn}
                onChange={handleFilterInputChange}
                onKeyDown={handleFilterKeyDown}
              />

                <Box w='800px'>
                  <DatePicker
                    // defaultDate={procedureDate}
                    onDateChange={(selectedDateValue) =>
                      handleFromDate(selectedDateValue)
                    }
                    placeholderProp="From Date"
                    datePickerInputStyle={{ borderRadius: "10px 10px 10px 10px" }}
                    value={fromDate}
                    clearValue={true}

                    CUSTOM_DISABLE={true}
                    disableFutureDates={true}
                    maxDate={toDateMinMax}
                  />
                </Box>
                <Box w='800px'>
                  <DatePicker
                    onDateChange={(selectedDateValue) =>
                      handleToDate(selectedDateValue)
                    }
                    placeholderProp="To Date"
                    datePickerInputStyle={{ borderRadius: "10px 10px 10px 10px " }}
                    value={toDate}
                    clearValue={true}

                    CUSTOM_DISABLE={true}
                    maxDate={new Date().toISOString()}
                    minDate={fromDateMinMax}

                  />
                </Box>

              <PrimaryInput
                variant="fullRound"
                title="Composition"
                inputPlace="Medicine Count"
                id="searchComposition"
                name="medicinecount"
                inputValue={search.medicinecount}
                onChange={handleFilterInputChange}
                onKeyDown={handleFilterKeyDown}
              />
             {!pharmacyId && (
                <DropdownInput
                  variant="fullSide"
                  dropDownPlace="Pharmacy Type"
                  options={pharmacyNamesList}       // array of strings
                  onClick={handlePharmacyNameChange}
                  value={selectedPharmacyName}
                  defaultOption={selectedPharmacyName || ""}
                />
              )}
              <PrimaryButton
                buttonText="Filter"
                id="filterButton"
                onClick={() => getFilteredResults()}
                btnStyle={{ m: "0", w: "150px" }}
              />
              <PrimaryButton
                buttonText="Reset"
                id="resetButton"
                variant="grayBtnFull"
                btnStyle={{ color: "#AA2F27", m: "0", w: "125px" }}
                onClick={resetFeilds}
              />
            </Box>
            <Divider />
            {data && data.length > 0 ? (
              <>
                <Box
                  width="100%"
                  // p="1rem"
                  overflow="hidden auto"
                  h="calc(100vh - 100px)"
                >
                  <SimpleTable
                    headers={TableHeader}
                    className="tableContainer"
                    isDataPresent={true}
                    // ref={tableRef}
                    footerStyle={{
                      pos: "fixed",
                      bottom: "0px",
                      left: "100px",
                      boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                    }}
                    tableStyle={{
                      maxH: "calc(100vh - 75px)",
                      overflowY: "auto",
                      tableLayout: "fixed",
                      width: "100%",
                    }}
                    tableBody={
                      <>
                        {data.map((item, index) => (
                          <Tr w="100%" index={index}>
                            <Td>
                              <Text>{item.urn}</Text>
                            </Td>
                            <Td>
                              <Text>{item.medicinecount}</Text>
                            </Td>
                            <Td>
                              <Text>{item.pharmacyname}</Text>
                            </Td>
                            <Td>
                              <Text>{item.doctorname}</Text>
                            </Td>
                            <Td>
                              <Text>
                                {formatDate_Do_MMM_YYYY(item.transferdate)}
                              </Text>
                            </Td>
                            <Td>
                              <Text>{formattedTime(item.transferdate)}</Text>
                            </Td>
                            <Td>
                              <Text>{item.status === 0 ? 'Dispatched'  : 'Requested'}</Text>
                            </Td>
                            <Td>
                              {item.status === 0 ? (
                                <PrimaryButton
                                  buttonText="View details"
                                  variant="grayBtn"
                                  onClick={()=>openTransferModal(item)}
                                  btnStyle={{ color: "#000", w: "100px" }}
                                />
                              ) : (
                                <PrimaryButton
                                  buttonText="Requested details"
                                  variant="grayBtn"
                                  onClick={()=> openRequestModal(item)}
                                  btnStyle={{ color: "#000", w: "150px" }}
                                />
                              )}
                            </Td>
                          </Tr>
                        ))}
                      </>
                    }
                    footerSection={
                      <>
                        {data && data.length > 0 && (
                          <Tr w="100%">
                            <Td colSpan={11} w="calc(100vw - 6.5rem)">
                              <Box
                                w="100%"
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <Box
                                  visibility={
                                    totalItemCount < countTo &&
                                    !totalExceedsPageCount
                                      ? "hidden"
                                      : "visible"
                                  }
                                >
                                  <Text>
                                    Showing <b>{countFrom}</b> to{" "}
                                    {/* Showing <b>1</b> to <b>2</b> of 20 results */}
                                    <b>{countTo}</b> of {totalItemCount} results
                                  </Text>
                                </Box>

                                <Box
                                  gap="2.5rem"
                                  display="flex"
                                  justifyContent="space-between"
                                  alignItems="center"
                                >
                                  <Box
                                    as="button"
                                    onClick={handlePrevClick}
                                    disabled={currentPage == 1}
                                    visibility={
                                      currentPage == 1 ? "hidden" : "visible"
                                    }
                                    p="0.5rem 0.75rem"
                                    border="0.0625rem solid #E6E7E9"
                                    borderRadius="0.75rem"
                                    fontSize=".875rem"
                                    fontWeight="500"
                                  >
                                    Previous
                                  </Box>
                                  <Box>
                                    <Text
                                      textAlign="center"
                                      fontSize=".875rem"
                                      fontWeight="600"
                                    >
                                      Page {currentPage} of {totalPages}
                                      {/* Page 1 of 20 */}
                                    </Text>
                                  </Box>
                                  {totalItemCount >= countTo &&
                                    !totalExceedsPageCount && (
                                      <Box
                                        as="button"
                                        p="0.5rem 0.75rem"
                                        mr="2.5rem"
                                        border="0.0625rem solid #E6E7E9"
                                        borderRadius="0.75rem"
                                        onClick={handleNextClick}
                                        disabled={currentPage == totalPages}
                                        visibility={
                                          currentPage == totalPages
                                            ? "hidden"
                                            : "visible"
                                        }
                                        fontSize=".875rem"
                                        fontWeight="500"
                                      >
                                        Next
                                      </Box>
                                    )}
                                </Box>
                              </Box>
                            </Td>
                          </Tr>
                        )}
                      </>
                    }
                  />
                </Box>
              </>
            ) : (
              <Box width="100%">
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  py="2rem"
                >
                  <Text fontSize="md" fontWeight="bold">
                    No Pharmacy Found
                  </Text>
                </Box>
              </Box>
            )}
          </Box>
        </Flex>
      </Box>

      <ModalRight
        ref={transferReportModal}
        header="Transfer Details Report"
        modalWidth={{ base: "100%", lg: "calc(100vw - 20%)" }}
        body={
          <>
            <Box p="4" borderRadius="md" w="100%">
              <Flex
                alignItems="center"
                gap="4"
                wrap="wrap"
                w="100%"
                justifyContent="space-between"
              >
                <Flex
                  justifyContent="center"
                  alignItems="center"
                  w="4rem"
                  border="1px solid #e2e2e2"
                  bg="#E6E7E966"
                  borderRadius="8px"
                >
                  <Text
                    fontSize="30px"
                    textAlign="center"
                    fontWeight="700"
                    p="8px 4px"
                  >
                    {selectedReport?.tranferdetails?.medicinecount}
                  </Text>
                </Flex>
                <Flex direction="column" mr="6">
                  <Flex align="center" gap="2">
                    <Box
                      as={IoDocumentTextOutline}
                      fontSize="18px"
                      color="gray.600"
                    />
                    <Text fontSize="sm" fontWeight="medium" color="gray.500">
                      URN
                    </Text>
                  </Flex>
                  <Text ml="3px" fontSize="md" fontWeight="bold">
                    {selectedReport?.tranferdetails?.urn || "-"}
                  </Text>
                </Flex>
                <Flex direction="column" mr="6">
                  <Flex align="center" gap="2">
                    <Box
                      as={MdOutlineLocalPharmacy}
                      fontSize="18px"
                      color="gray.600"
                    />
                    <Text fontSize="sm" fontWeight="medium" color="gray.500">
                      Pharmacy Name
                    </Text>
                  </Flex>
                  <Text ml="3px" fontSize="md" fontWeight="bold">
                    {selectedReport?.tranferdetails?.pharmacyname || "-"}
                  </Text>
                </Flex>
                <Flex direction="column" mr="6">
                  <Flex align="center" gap="2">
                    <Box as={FiCalendar} fontSize="18px" color="gray.600" />
                    <Text fontSize="sm" fontWeight="medium" color="gray.500">
                      DATE
                    </Text>
                  </Flex>
                  <Text fontSize="md" fontWeight="bold">
                    {formatDate_Do_MMM_YYYY(
                      selectedReport?.tranferdetails?.createddate
                    ) || "-"}
                  </Text>
                </Flex>

                <Flex direction="column" mr="6">
                  <Flex align="center" gap="2">
                    <Box as={FiClock} fontSize="18px" color="gray.600" />
                    <Text fontSize="sm" fontWeight="medium" color="gray.500">
                      TIME
                    </Text>
                  </Flex>
                  <Text fontSize="md" fontWeight="bold">
                    {formattedTime(selectedReport?.tranferdetails?.createddate) || "-"}
                  </Text>
                </Flex>

                <Flex direction="column">
                  <Flex align="center" gap="2">
                    <Box as={FiUser} fontSize="18px" color="gray.600" />
                    <Text fontSize="sm" fontWeight="medium" color="gray.500">
                      INITIATED BY
                    </Text>
                  </Flex>
                  <Text fontSize="md" fontWeight="bold">
                    {selectedReport?.tranferdetails?.doctorname || "-"}
                  </Text>
                </Flex>
              </Flex>
            </Box>
            <Divider />
            {selectedReport?.data && selectedReport?.data?.length > 0 ? (
              <>
                <Box
                  width="100%"
                  // p="1rem"
                  overflow="hidden auto"
                  h="calc(100vh - 100px)"
                >
                  <SimpleTable
                    headers={ModalTable}
                    className="tableContainer"
                    isDataPresent={true}
                    footerStyle={{
                      pos: "fixed",
                      bottom: "0px",
                      left: "100px",
                      boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                    }}
                    tableStyle={{
                      maxH: "calc(100vh - 75px)",
                      overflowY: "auto",
                      tableLayout: "fixed",
                      width: "100%",
                    }}
                    tableBody={
                      <>
                        {selectedReport?.data?.map((item, index) => (
                          <Tr w="100%" index={index}>
                            <Td
                              display="flex"
                              gap={"0.5rem"}
                              alignItems="center"
                            >
                              <Text>{item.productname || "-"}</Text>
                              {item.producttype && (
                                <Box
                                as="span"
                                bg="#E6E7E966"
                                mr="0.25rem"
                                border="1px solid #E6E7E9"
                                borderRadius="8px"
                                fontSize="10px"
                                px="8px"
                                >
                                {item.producttype}
                              </Box>
                              )}
                            </Td>
                            <Td>
                              <Text>{item.dosage + " " + item.dosageunit}</Text>
                            </Td>
                            <Td>
                              <Text>{item.batchnumber || "-"}</Text>
                            </Td>
                            {/* <Td>
                              <Text>{item.chemicalcomposition}</Text>
                            </Td> */}
                            <Td>
                              <Text>
                                {item.expirydate || "-"}
                              </Text>
                            </Td>
                            <Td>
                              <Text>{item.manufacturername || "-"}</Text>
                            </Td>
                            <Td>
                              <Text>{item?.remainingquantity || "-"}</Text>
                            </Td>
                          </Tr>
                        ))}
                      </>
                    }
                  />
                </Box>
              </>
            ) : (
              <Box width="100%">
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  py="2rem"
                >
                  <Text fontSize="md" fontWeight="bold">
                    No Pharmacy Found
                  </Text>
                </Box>
              </Box>
            )}
          </>
        }
      />

      <ModalRight
        ref={openReqModal}
        header="Requested Details"
        modalWidth={{ base: "100%", lg: "calc(100vw - 40%)" }}
        body={
          <>
            <Flex>
              {/* {isLoading && <Loader />} */}
              <Box
                w="calc(100vw - 6.25rem)"
                display="flex"
                flexDir="column"
                id="print-content"
              >
                <Box>
                    <Box display="flex" mb='1rem' mt='0.875rem' w='100%' flexDirection="row" justifyContent="space-between" alignItems="center" >
                      <Text fontWeight="600" fontSize="1rem">
                        Initiated By: <Box as="span" fontSize='1rem' fontWeight="500">{selectedReport?.tranferdetails?.doctorname}</Box>  
                      </Text>
                      <Text fontWeight="600" fontSize="1rem">
                        Date: <Box as="span" fontSize='1rem' fontWeight="500">{moment(selectedReport?.tranferdetails?.createddate).format('Do MMMM YYYY')}</Box> 
                      </Text>
                    </Box>

                    <Box display="flex" flexDir="row">
                      <PrimaryInput
                        type="text"
                        variant="bothSide"
                        inputPlace="URN (Unique Reference Number)"
                        inputValue={selectedReport?.tranferdetails?.urn}
                        readOnly
                        inputCssStyle={{bg:COLORS.BTN_DISABLE}}
                        width={"30%"}
                        />
                      <DropdownInput
                        variant="bothSide"
                        dropDownPlace="Select Pharmacy"
                        // options={[]}
                        value={selectedReport?.tranferdetails?.pharmacyname}
                        // onClick={handlePharmacyChange}
                        //   onChange={handlePharmacySelect}
                        readOnly={true}
                        optionStyle={{ disabled: true }}
                        isdisabled={true}
                        id="pharmacy-select"
                        menuList={{ pos: "absolute", right: "48px", minW: "285px" }}
                      />
                    </Box>
                </Box>

                <Box
                  id="printableDiv2"
                  w="100%"
                  p="1.5rem 0 1.5rem"
                  minH="calc(100vh - 240px)"
                  maxH="calc(100vh - 240px)"
                  overflow="hidden auto"
                >
                  
                    <SimpleTable
                      isTh={false}
                      isDataPresent={true}
                      ThStyle={{ textAlign: "center", bg: "#FAFAFA" }}
                      footerStyle={{
                        pos: "sticky",
                        bottom: "-1px",
                        boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                      }}
                      tableStyle={{
                        tableLayout: "fixed",
                        width: "100%",
                        border: "1px solid #E6E7E9",
                        borderBottom: "none",
                      }}
                      tableHeaders={
                        <Tr>
                          <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                            Medicine name
                          </Th>
                          <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                            Batch no
                          </Th>
                          <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                            Quantity (In Units)
                          </Th>
                          <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                            Requested Qty
                          </Th>
                          <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                            <Flex
                              w="100%"
                              justifyContent="center"
                              alignItems="center"
                            >
                              <PrimaryButton
                                btnIcon="/assets/svgs/add-white.svg"
                                iconSrc={true}
                                btnStyle={{ w: "25px", h: "25px", p: "0" }}
                                iconSrcStyle={{ mr: "0", w: "10px" }}
                                onClick={AddAnotherRowPrescription}
                              />
                            </Flex>
                          </Th>
                        </Tr>
                      }
                      tableBody={
                        <>
                          {selectedReport?.data?.map((row, index) => (
                            <Tr w="100%" key={`selectedReport-${index}`}>
                              <Td p="0">
                                <Box w="100%" pos="relative" cursor="pointer" ref={medicineRef}>
                                  <PrimaryInput
                                    variant="bothSide"
                                    inputPlace="Medicine name*"
                                    id={`medicinename-${index}`}
                                    inputValue={`${row.productname || ''} ${row.dosage || ''} ${row.dosageunit || ''} ${row.producttype || ''}`.trim()}
                                    // inputIdProp={
                                    //   inputId == index ? "Active" : null
                                    // }
                                    boolProp={boolValForSuggestions}
                                    autocomplete="off"
                                    inputCssStyle={{pr:"36px",bg:COLORS.BTN_DISABLE,_hover:{border: "1px solid", borderRadius: "10px"}}}
                                    maxLength={50}
                                    readOnly={true} 
                                  />
                                </Box>
                              </Td>


                              <Td p="0">
                                <Box w="100%" pos="relative" cursor="pointer">
                                  <PrimaryInput
                                    variant="bothSide"
                                    inputPlace="Batch No"
                                    inputValue={row.batchnumber}
                                    onChange={(e) => {
                                      // If you want to allow manual typing, update batchnumber here too:
                                      setSelectedReport(prev => {
                                        if (!prev?.data) return prev;
                                        const updatedData = [...prev.data];
                                        updatedData[index] = { ...updatedData[index], batchnumber: e.target.value };
                                        return { ...prev, data: updatedData };
                                      });
                                    }}
                                    onClick={() => {
                                      FetchBatchList(row);
                                      setShowBatchDropdownSelectedReport(index);
                                    }}
                                    inputCssStyle={{pr:"36px",_hover:{border: "1px solid", borderRadius: "10px"}}}
                                    maxLength={30}
                                  />
                                </Box>
                                {showBatchDropdownSelectedReport === index && batchData.length > 0 && (
                                <Menu isOpen={true} onClose={() => setShowBatchDropdownSelectedReport(-1)}>
                                <MenuButton
                                  as={Box}
                                  w="100%"
                                  display="block"
                                  pos="relative"
                                  zIndex="999"
                                >
                                  <Box
                                    pos="absolute"
                                    top="100%"
                                    left="0"
                                    w="100%"
                                    bg="white"
                                    borderTop="none"
                                    border="1px solid #E6E7E9"
                                    borderRadius="0 0 12px 12px"
                                  />
                                </MenuButton>
                                <MenuList
                                  w="100%"
                                  borderRadius="0 0 12px 12px"
                                  zIndex="999"
                                  bg="white"
                                  maxH="150px"
                                  overflow="hidden auto"
                                  ref={suggestionsMenuRef}
                                >
                                {batchData.map((batch, bIndex) => (
                                    <MenuItem
                                      key={bIndex}
                                    //   onClick={() =>
                                    //     handleSelect(suggestion, index)
                                    //   }
                                      onClick={() => {
                                        if(row.batchnumber){
                                          return;
                                        }else {
                                          handleBatchSelectSelectedReport(batch, index);
                                          setShowBatchDropdownSelectedReport(-1)
                                        }
                                      }}
                                      cursor="pointer"
                                      p="1rem"
                                      py="0.5rem"
                                      borderBottom="1px solid #E6E7E9"
                                      bg={
                                        focusedItemIndex === bIndex
                                          ? "#f0f0f0"
                                          : "white"
                                      } // Highlight focused item
                                    >
                                      <Text
                                        fontSize="0.875rem"
                                        fontWeight="500"
                                      >
                                        {batch.batchnumber} ({batch.remainingquantity} Qty) {batch.expirydate}
                                      </Text>
                                    </MenuItem>
                                  ))}
                                </MenuList>
                                </Menu>
                                  )}
                              </Td>
                              <Td p="0">
                                <Box w="100%" pos="relative" cursor="pointer">
                                  <PrimaryInput
                                    variant="bothSide"
                                    inputPlace="Quantity"
                                    inputValue={editableQuantities[index]}
                                    inputCssStyle={{pr:"36px",_hover:{border: "1px solid", borderRadius: "10px"}}}
                                    maxLength={30}
                                    // onChange={(e) => {
                                    //   const value = e.target.value;
                                    //   // Allow only digits (no decimals, no characters)
                                    //   if (/^\d*$/.test(value)) {
                                    //     handleQuantityChangeSelectedReport(value, index);
                                    //   }
                                    // }}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (/^\d*$/.test(value)) {
                                        const newQtys = [...editableQuantities];
                                        newQtys[index] = value === '' ? '' : parseInt(value);
                                        // console.log(editableQuantities[index], "newQtys");
                                        setShowRemove(null)
                                        setEditableQuantities(newQtys);
                                      }
                                    }}
                                  />
                                </Box>
                              </Td>
          
                              <Td p="0">
                                <PrimaryInput
                                  ref={quantityRef}
                                  variant="bothSide"
                                  inputPlace="Requested Qty"
                                  id="quantity"
                                  inputValue={row.requestedquantity}
                                  readOnly={true} 
                                  maxLength={7}
                                  inputCssStyle={{bg:COLORS.BTN_DISABLE,_hover:{border: "1px solid", borderRadius: "10px"}}}
                                />
                              </Td>

                              <Td p="0">
                                <Box
                                  as="button"
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  w="100%"
                                  onClick={() => confirmDeleteRow(index,'selectedReport')}
                                >
                                  {showRemove === index ? (
                                    <Text color='red' fontSize='0.875rem'>Removed</Text>
                                  ) : (
                                    <Image
                                      src="/assets/svgs/delete.svg"
                                      opacity="0.7"
                                    />
                                  )}
                                </Box>
                              </Td>
                            </Tr>
                          ))}

                          {/* Editable rows */}
                          {rows.map((row, index) => (
                            <Tr w="100%" key={`newRows-${index}`}>
                              <Td p="0">
                                <Box w="100%" pos="relative" cursor="pointer" ref={medicineRef}>
                                  <PrimaryInput
                                    variant="bothSide"
                                    inputPlace="Medicine name*"
                                    id={`medicinename-${index}`}
                                    inputValue={`${row.medicinename || ''} ${row.dosage || ''} ${row.dosageunit || ''} ${row.medicinetype || ''}`.trim()}
                                    onChange={(e) =>
                                      handleMedicineNameChange(
                                        row.inventoryid,
                                        e.target.value,
                                        index
                                      )
                                    }
                                    // inputIdProp={
                                    //   inputId == index ? "Active" : null
                                    // }
                                    boolProp={boolValForSuggestions}
                                    onKeyDown={(e) => handleKeyDown(e, index)}
                                    autocomplete="off"
                                    inputCssStyle={{pr:"36px",_hover:{border: "1px solid", borderRadius: "10px"}}}
                                    maxLength={50}
                                  />
                                  <Image
                                    top="33%"
                                    right="6.5%"
                                    w="15px"
                                    pos="absolute"
                                    src="/assets/imgs/search.png"
                                  />
                                </Box>
                                {showMedicineNamesDropdown === index &&
                                  suggestions.length > 0 && (
                                    <Menu isOpen={true}>
                                      <MenuButton
                                        as={Box}
                                        w="100%"
                                        display="block"
                                        pos="relative"
                                        zIndex="999"
                                      >
                                        <Box
                                          pos="absolute"
                                          top="100%"
                                          left="0"
                                          w="100%"
                                          bg="white"
                                          borderTop="none"
                                          border="1px solid #E6E7E9"
                                          borderRadius="0 0 12px 12px"
                                        />
                                      </MenuButton>
                                      <MenuList
                                        w="100%"
                                        borderRadius="0 0 12px 12px"
                                        zIndex="999"
                                        bg="white"
                                        maxH="150px"
                                        overflow="hidden auto"
                                        ref={suggestionsMenuRef}
                                      >
                                        {suggestions.map((suggestion, sIndex) => (
                                          <MenuItem
                                            key={sIndex}
                                            onClick={() =>
                                              handleSelect(suggestion, index)
                                            }
                                            cursor="pointer"
                                            p="1rem"
                                            py="0.5rem"
                                            borderBottom="1px solid #E6E7E9"
                                            bg={
                                              focusedItemIndex === sIndex
                                                ? "#f0f0f0"
                                                : "white"
                                            } 
                                          >
                                            <Text
                                              fontSize="0.875rem"
                                              fontWeight="500"
                                            >
                                              {suggestion.medicinename} {suggestion.dosage} {suggestion.dosageunit} {suggestion.medicinetype}
                                            </Text>
                                          </MenuItem>
                                        ))}
                                      </MenuList>
                                    </Menu>
                                  )}
                              </Td>


                              <Td p="0">
                                <Box w="100%" pos="relative" cursor="pointer">
                                  <PrimaryInput
                                    variant="bothSide"
                                    inputPlace="Batch No"
                                    inputValue={row.batchnumber}
                                    onChange={(e) => handleBatchNumberChange(e.target.value, index)}
                                    onClick={() => {
                                      FetchBatchList(row);
                                      setShowBatchDropdown(index);
                                    }}
                                    inputCssStyle={{pr:"36px",_hover:{border: "1px solid", borderRadius: "10px"}}}
                                    maxLength={30}
                                    readOnly={true} 
                                  />
                                </Box>
                                {showBatchDropdown === index && batchData.length > 0 && (
                                <Menu isOpen={true} onClose={() => setShowBatchDropdown(-1)}>
                                <MenuButton
                                  as={Box}
                                  w="100%"
                                  display="block"
                                  pos="relative"
                                  zIndex="999"
                                >
                                  <Box
                                    pos="absolute"
                                    top="100%"
                                    left="0"
                                    w="100%"
                                    bg="white"
                                    borderTop="none"
                                    border="1px solid #E6E7E9"
                                    borderRadius="0 0 12px 12px"
                                  />
                                </MenuButton>
                                <MenuList
                                  w="100%"
                                  borderRadius="0 0 12px 12px"
                                  zIndex="999"
                                  bg="white"
                                  maxH="150px"
                                  overflow="hidden auto"
                                  ref={suggestionsMenuRef}
                                >
                                {batchData.map((batch, bIndex) => (
                                    <MenuItem
                                      key={bIndex}
                                    //   onClick={() =>
                                    //     handleSelect(suggestion, index)
                                    //   }
                                      onClick={() => {
                                        handleBatchSelect(batch, index);
                                        setShowBatchDropdown(-1);
                                      }}
                                      cursor="pointer"
                                      p="1rem"
                                      py="0.5rem"
                                      borderBottom="1px solid #E6E7E9"
                                      bg={
                                        focusedItemIndex === bIndex
                                          ? "#f0f0f0"
                                          : "white"
                                      } // Highlight focused item
                                    >
                                      <Text
                                        fontSize="0.875rem"
                                        fontWeight="500"
                                      >
                                        {batch.batchnumber} ({batch.remainingquantity} Qty) {batch.expirydate}
                                      </Text>
                                    </MenuItem>
                                  ))}
                                </MenuList>
                                </Menu>
                                  )}
                              </Td>
          
                              <Td p="0">
                                <PrimaryInput
                                  ref={quantityRef}
                                  variant="bothSide"
                                  inputPlace="Quantity*"
                                  id="quantity"
                                  inputValue={row.quantity}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    // Allow only digits (no decimals, no characters)
                                    if (/^\d*$/.test(value)) {
                                      handleQuantityChange(value, index);
                                    }
                                  }}
                                  maxLength={7}
                                  inputCssStyle={{_hover:{border: "1px solid", borderRadius: "10px"}}}
                                />
                              </Td>
                              <Td p="0">
                                <PrimaryInput
                                  ref={quantityRef}
                                  variant="bothSide"
                                  inputPlace="Requested Quantity*"
                                  id="quantity"
                                  inputValue={row.quantity}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    // Allow only digits (no decimals, no characters)
                                    if (/^\d*$/.test(value)) {
                                      handleQuantityChange(value, index);
                                    }
                                  }}
                                  readOnly={true}
                                  maxLength={7}
                                  inputCssStyle={{bg:COLORS.BTN_DISABLE,_hover:{border: "1px solid", borderRadius: "10px"}}}
                                />
                              </Td>

                              <Td p="0">
                                <Box
                                  as="button"
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                  w="100%"
                                  onClick={() => confirmDeleteRow(index)}
                                >
                                  <Image
                                    src="/assets/svgs/delete.svg"
                                    opacity="0.7"
                                  />
                                </Box>
                              </Td>
                            </Tr>
                          ))}
                        </>
                      }
                    />
                  
                  
                </Box>
                            
              </Box>
            </Flex>    
          </>
        }

        footerActions={
            <PrimaryButton buttonText="Confirm Transfer" btnStyle={{width: "200px"}} onClick={handleSaveTransfer} />
        }
      />

       <DynamicModal
        ref={deleteReqModal}
        modalHeader="Delete row"
        modalBody={
          <>
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to delete?
            </Text>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Delete"
              onClick={deleteRowHandler}
            />
          </>
        }
      />
       
       <DynamicModal
        ref={deleteRowModal}
        modalHeader="Delete row"
        modalBody={
          <>
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to delete?
            </Text>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Delete"
              onClick={deleteRowHandler}
            />
          </>
        }
      />
    </>
  );
};

export default MasterTransferReportByPharmacy;
